import { Evaluation } from '@/apis/evaluations/types/evaluationsApi';
import { DataItems, LabeledIcon } from '@/components';
import { MOBILE_WIDTH } from '@/constants';
import { formatDateString } from '@/utils';
import {
  BoxAppstore,
  Chip,
  Stack,
  TextTruncate,
  Typography,
  useWindowSize,
} from '@data-products-and-ai/react-components';
import { FC, useMemo } from 'react';

interface MillwrightEvaluationProps {
  evaluation: Evaluation;
}

export const MillwrightEvaluation: FC<MillwrightEvaluationProps> = ({
  evaluation,
}) => {
  const { width } = useWindowSize();

  const dataItems = useMemo(
    () => [
      {
        key: 'evaluator',
        label: 'Evaluator',
        value: <LabeledIcon icon="IconUser" label={evaluation.evaluatorName} />,
      },

      {
        key: 'eval',
        hideLabel: true,
        single: width <= MOBILE_WIDTH,
        value: (
          <Stack direction="row" gap={8}>
            <Chip
              label={evaluation?.eval?.toString() ?? '-'}
              color="primary"
              chipType="thin"
              size="extra-small"
            />
            <Typography color="var(--color-default)" tag="textsmall">
              out of
            </Typography>
            <Typography color="var(--color-black)" tag="textsmall_strong">
              4
            </Typography>
          </Stack>
        ),
      },
      {
        key: 'evaluationDate',
        label: 'Evaluation Date',
        value: evaluation?.evalDate
          ? formatDateString(evaluation.evalDate, 'MMMM Do, YYYY')
          : 'N/A',
      },
      {
        key: 'outage',
        label: 'Outage',
        single: width <= MOBILE_WIDTH,
        value: `${evaluation?.outageName ?? 'N/A'} (${evaluation?.outageId})`,
      },
      {
        key: 'notes',
        label: 'Notes',
        value: (
          <TextTruncate width="100%" showMoreText showLessText lines={2}>
            {!evaluation?.notes || evaluation.notes === '\n'
              ? 'N/A'
              : evaluation.notes}
          </TextTruncate>
        ),
        single: true,
      },
    ],
    [evaluation, width],
  );
  return (
    <BoxAppstore>
      <DataItems items={dataItems} />
    </BoxAppstore>
  );
};
